import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ru from './locales/ru/common.json';
import en from './locales/en/common.json';

const savedLang = localStorage.getItem('lang');
const initialLang = savedLang === 'en' || savedLang === 'ru' ? savedLang : 'ru';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
    },
    lng: initialLang,
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
